import { WorkFlowStageModel } from './work-flow-stage-model';

export class OperationPrivilageModel {
    userRole: string;
    lastUpdatedUser: string;
    workflowStageCode: string;
    workflowStageCodes: WorkFlowStageModel[];
    url: string;
}
